import {
    UpdateUserResponse,
    ForgotPasswordRequest,
    ForgotPasswordResponse,
    LoginBody,
    LoginResponse,
    ChangePasswordRequest,
    ChangePasswordResponse,
    ResetPasswordRequest,
    ResetPasswordResponse,
} from './types';

import API from 'utils/api';

export function login(params: LoginBody) {
    return API.post<LoginResponse>(`Users/LoginByEmail`, params);
}

export const forgotPassword = (params: ForgotPasswordRequest) => {
    return API.post<ForgotPasswordResponse>(`Users/ForgetPassword`, params);
};

export function updateUser(params: FormData) {
    return API.put<UpdateUserResponse>(`Users/UpdateUser`, params);
}

export function changePassword(params: ChangePasswordRequest) {
    return API.put<ChangePasswordResponse>(`Users/ChangePassword`, params);
}

export function resetPassword(params: ResetPasswordRequest) {
    return API.put<ResetPasswordResponse>(`Users/ResetPassword`, params);
}
